import api from '../api/axios';

export const checkCandidateDuplicate = (body) =>
  api.post('/api/candidates/check-duplicate', body).then((r) => r.data);
export const uploadCandidate = (formData) => api.post('/Candidates', formData).then((r) => r.data);
export const getCandidateCounts = (userId, reqIds = []) => {
  const params = reqIds.length > 0 ? { reqIds: reqIds.join(',') } : undefined;
  return api.get(`/candidateCounts/${userId}`, { params }).then((r) => r.data);
};
export const getViewActions = (id, userId) => api.get(`/viewactions/${id}/${userId}`).then((r) => r.data);
export const deleteCandidate = (id) => api.delete(`/api/candidates/${id}`).then((r) => r.data);
export const getAdminViewActions = (id) => api.get(`/adminviewactions/${id}`).then((r) => r.data);
export const getRecruiters = (reqId) => api.get(`/api/recruiters/${reqId}`).then((r) => r.data);
export const getUserUploads = (reqId, userId) => api.get(`/userUploads/${reqId}/${userId}`).then((r) => r.data);
export const getCandidates = (recruiterId, reqId) => api.get('/api/candidates', { params: { recruiterId, reqId } }).then((r) => r.data);
export const getCandidateById = (id) => api.get(`/candidate/${id}`).then((r) => r.data);
export const updateCandidate = (id, body) => api.put(`/candidates/${id}`, body).then((r) => r.data);
export const updateCandidateDocuments = (candidateId, formData) =>
  api.patch(`/api/candidates/${candidateId}/documents`, formData).then((r) => r.data);
export const getRejectedCandidates = (requirementId, userId) =>
  api.get(`/api/requirements/${requirementId}/rejected-candidates`, {
    params: userId ? { userId } : undefined,
  }).then((r) => r.data);
export const addStatusRemark = (candidateId, statusEntryId, remark) =>
  api.post(`/api/candidates/${candidateId}/status/${statusEntryId}/remarks`, { remark }).then((r) => r.data);
export const updateCandidateStatus = (candidateId, body) => api.put(`/updatestatus/${candidateId}`, body).then((r) => r.data);
